//
// アンケートフォーム画面
//
import Validator from 'validatorjs'
require('./validator_ja')

window.addEventListener('pageshow', (element) => {
  const pages = document.querySelectorAll('.nanovation-forms-page')
  if (pages.length == 0) return;

  Validator.useLang('ja')
  function validate(input) {
    const { validatorRules: rules, validatorName: name } = input.dataset
    let val = input.value

    if (/between|max/.test(rules)) { val = val.replace(/\r?\n/g, '') }

    const validation = new Validator({ val }, { val: rules })
    validation.setAttributeNames({ val: name })

    if (validation.fails()) {
      displayValidateMessage(input, validation.errors.get('val'))

      return false
    } else {
      removeValidateMessage(input)

      return true
    }
  }

  function validateRadio(radioInput) {
    const { validatorRules: rules, validatorName: name } = radioInput.dataset
    const val = radioInput.querySelector('input:checked')
    const validation = new Validator({ val }, { val: rules })
    validation.setAttributeNames({ val: name })

    if (validation.fails()) {
      displayValidateMessage(radioInput, validation.errors.get('val'))

      return false
    } else {
      removeValidateMessage(radioInput)

      return true
    }
  }

  function validateCheckbox(checkboxInput) {
    const { validatorRules: rules, validatorName: name } = checkboxInput.dataset
    const val = checkboxInput.querySelector('input').checked
    const validation = new Validator({ val }, { val: rules })
    validation.setAttributeNames({ val: name })

    if (validation.fails()) {
      displayValidateMessage(checkboxInput, validation.errors.get('val'))

      return false
    } else {
      removeValidateMessage(checkboxInput)

      return true
    }
  }

  for (let input of document.querySelectorAll('input[data-validator-rules], textarea[data-validator-rules], select[data-validator-rules]')) {
    input.addEventListener('focusout', (ev) => {
      validate(ev.target)
    })
  }

  for (let radioElement of document.getElementsByClassName('radio-wrapper')) {
    radioElement.addEventListener('change', () => {
      validateRadio(radioElement)
    })
  }

  for (let checkboxElement of document.getElementsByClassName('checkbox-wrapper')) {
    checkboxElement.addEventListener('change', () => {
      validateCheckbox(checkboxElement)
    })
  }

  const form = document.querySelector('form')
  form.addEventListener('submit', (ev) => {
    let validateResults = []
    for (let radioElement of document.getElementsByClassName('radio-wrapper')) {
      validateResults.push(validateRadio(radioElement))
    }
    for (let input of document.querySelectorAll('input[data-validator-rules], textarea[data-validator-rules], select[data-validator-rules]')) {
      validateResults.push(validate(input))
    }
    for (let checkboxElement of document.getElementsByClassName('checkbox-wrapper')) {
      validateResults.push(validateCheckbox(checkboxElement))
    }
    if (validateResults.indexOf(false) != -1) { cancelSubmit(ev) }
  })

  function displayValidateMessage(input, validateMessage) {
    removeValidateMessage(input)

    const messageElement = document.createElement('span')
    const messageText = document.createTextNode(validateMessage)

    messageElement.className = 'validate-message'
    messageElement.appendChild(messageText)
    messageElement.style.cssText = 'font-size: 1.2rem; font-weight: bold; color: red;'

    input.parentNode.appendChild(messageElement)
  }

  function removeValidateMessage(input) {
    const formNode = input.parentNode
    const validateElements = formNode.getElementsByClassName('validate-message')
    if(validateElements.length != 0) { formNode.removeChild(validateElements[0]) }
  }

  function cancelSubmit(event) {
    event.preventDefault()
    alert('入力が不足している項目があります。項目をご確認ください。')

    // submitボタンに指定されたdisable_withによりdisabledがセットされるためdisabledのセットが確実に行われてからここでdisabledを解除。
    window.setTimeout(function() {
      const button = document.querySelector('input:disabled')
      if (button != null) { button.disabled = false }
    }, 100)
  }
})
